import { FullStory, init } from '@fullstory/browser';
import { injectable, symbolToken } from '@servicetitan/react-ioc';
import { ApiModels } from '../../api';

const ENV_ID = process.env.ENV_ID;
export const FULLSTORY_API_TOKEN = symbolToken<IFullStoryApi>('FULLSTORY_API_TOKEN');

export interface IFullStoryApi {
    initialize(user?: ApiModels.User): Promise<void>;
}

@injectable()
export class FullStoryApi implements IFullStoryApi {
    private loadingPromise?: Promise<void>;

    async initialize(user?: ApiModels.User) {
        if (ENV_ID === 'cypress' || typeof window === 'undefined') {
            // eslint-disable-next-line no-console
            console.log('FullStory disabled in cypress env');
            return;
        }
        this.loadingPromise ??= new Promise<void>(resolve => {
            init({
                debug: false,
                orgId: '8HR7J',
            });
            FullStory('observe', {
                type: 'internal/fs-init',
                callback: () => {
                    FullStory('setIdentity', {
                        uid: user?.visitorId ?? 'Anonymous',
                        properties: {
                            email: user?.email,
                            displayName: user?.userDisplayName,
                            // eslint-disable-next-line @typescript-eslint/naming-convention
                            username_str: user?.userName,
                            // eslint-disable-next-line @typescript-eslint/naming-convention
                            companyName_str: 'IntelligentSupportHub',
                            // eslint-disable-next-line @typescript-eslint/naming-convention
                            server_str: 'support-hub.servicetitan.com',
                        },
                    });
                    resolve();
                },
            });
        });
        await this.loadingPromise;
    }
}
